import { render, staticRenderFns } from "./footerTemp.vue?vue&type=template&id=4d2ac912&scoped=true&"
import script from "./footerTemp.vue?vue&type=script&lang=js&"
export * from "./footerTemp.vue?vue&type=script&lang=js&"
import style0 from "./footerTemp.vue?vue&type=style&index=0&id=4d2ac912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ac912",
  null
  
)

export default component.exports